export default __webpack_public_path__ + "static/media/upload.c6c46468.svg";